/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Members_Add_Summary_ToastInputs */



/**
* | output |
* | --- |
* | "{count} member(s) invited successfully" |
*
* @param {Members_Add_Summary_ToastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_summary_toast = /** @type {((inputs: Members_Add_Summary_ToastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Summary_ToastInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Mitglied(er) erfolgreich eingeladen`)
	return /** @type {LocalizedString} */ (`${i?.count} member(s) invited successfully`)
});